/* eslint-disable prettier/prettier */
import { useUserProfile } from '../hooks/useUserProfile';
import CoachManageUsersPage from '../pages/ManageUsersPage';
import SuperAdminManageUsersPage from '../pages/ManageUsersAdminPage';

const ManageUsersRedirect = () => {
	const { profile, loading, error } = useUserProfile();

	if (loading) return null;
	if (error || !profile) return null;

	const role = profile.rolename?.toLowerCase();

	switch (role) {
		case 'superadmin':
			return <SuperAdminManageUsersPage />;

		case 'coach':
			return <CoachManageUsersPage />;

		default:
			return null;
	}
};

export default ManageUsersRedirect;
